export enum WordState {
  guessed = 'guessed',
  recentlyGuessed = 'recentlyGuessed',
  notGuessed = 'notGuessed',
  suggested = 'suggested',
  recentlySuggested = 'recentlySuggested',
  revealFirstLetter = 'revealFirstLetter'
}
